import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { UpdateUser } from '../../api/api';
import { passwordProblem, DEFAULT_PASSWORD } from '../../utils/authFlow';
import { endSessionLog } from '../../utils/session';

// Change password. Two modes:
//  • forced   — mustChangePassword (password still '1234'): no way out except
//               changing it or logging out (the router sends every /app route here).
//  • voluntary — from Profile → "Change password"; has a Back button.
export function useChangePassword() {
  const { user, mustChangePassword, passwordChanged, logout } = useAuth();
  const nav = useNavigate();
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    const problem = passwordProblem(pw, user?.MobileNumber);
    if (problem) { setErr(problem); return; }
    if (pw !== confirm) { setErr('Passwords do not match'); return; }
    setBusy(true);
    try {
      await UpdateUser({ data: { Password: pw, UpdatedBy: user.UserId }, where: `UserId = ${user.UserId}` });
      passwordChanged(pw);
      nav('/app', { replace: true });
    } catch {
      setErr('Could not save the new password. Check your connection and try again.');
    } finally {
      setBusy(false);
    }
  };

  const doLogout = () => { endSessionLog(); logout(); nav('/', { replace: true }); };
  const back = () => nav(-1);

  return {
    user, mustChangePassword, defaultPassword: DEFAULT_PASSWORD,
    pw, setPw, confirm, setConfirm, show, setShow, busy, err, submit, doLogout, back,
  };
}
